export const WHO5 = 
{
    Metadata:{Name:'WHO-5',maxColumn:6,numRows:5},
    Sections:
    [
        {
            Headers:[
                "",
                "All of the time",
                "Most of the time",
                "More than half of the time",
                "Less than half of the time",
                "Some of the time",
                "At no time"
            ],
            Questions:[
                {
                    Prompt:"I have felt cheerful in good spirits",
                    Responses:[
                        {Value:5,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"I have felt calm and relaxed",
                    Responses:[
                        {Value:5,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"I have felt active and vigorous",
                    Responses:[
                        {Value:5,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"I woke up feeling fresh and rested",
                    Responses:[
                        {Value:5,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"My daily life has been filled with things that interest me",
                    Responses:[
                        {Value:5,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
            ]
        }
    ]
}